import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import InjazHeader from "../components/HeaderEn/";
import Login from "../scenes/Injaz-LoginScreen";
import PosLogin from "../scenes/pos-LoginScreen";
import Dashboard from "../scenes/Injaz-Dashboard";
import english from "../translation/injaz-english.json";
import arabic from "../translation/injaz-arabic.json";
import { Layout, message } from "antd";
import POS from "../scenes/pos/pos";
// import ClientSelectionForm from "../scenes/injaz-ClientSelectionForm";
// import OrderList from "../components/OrderList/OrderList.jsx";
// import Productupdateingredientsprint from "../components/Productupdateingredientsprint/index";

// This is Main Routing Code where Routing Logic is Written
// Our Main Navigation Screens Are Login Page, DashBoard, Select Client. PosLogin, POS SCREEN
// We Have Import on top react-router-dom this package
// BrowserRouter is wrapper that wrap Route components,
const { Content } = Layout;

let language = {};
if (localStorage.getItem("lang")) {
  let currentLang = localStorage.getItem("lang");
  if (currentLang === "EN") {
    language = english;
  } else {
    language = arabic;
  }
} else {
  localStorage.setItem("lang", "EN");
  window.location.reload();
}

class Routers extends React.Component {
  render() {
    message.config({
      top: 0,
      duration: 1,
      maxCount: 3,
      rtl: true,
    });

    return (
      <Router>
        <Switch>
          <Route exact path="/" render={() => <Login language={language} />} />
          <Route
            path="/dashboard"
            render={() => <Dashboard language={language} />}
          />
          <Route path="/pos" render={() => <POS language={language} />} />
          <Route
            path="/poslogin/"
            render={() => <PosLogin language={language} />}
          />
          {/* <Route
			  path="/selectclient"
			  render={() => <ClientSelectionForm language={language} />}
			/> */}
          {/* <Route
            exact
            path="/productupdateingredientsprint"
            render={() => <Productupdateingredientsprint language={language} />}
          /> */}
          {/* <Route path="/orderslist" render={() =>
						<Fragment>
							<InjazHeader posProps={true} />
							<Content style={{ paddingTop: 24, background: '#ecf0f5', width: '100%' }}>
								<OrderList language={language} />
							</Content>
						</Fragment>
					}
					/> */}
        </Switch>
      </Router>
    );
  }
}

export default Routers;
